import React from 'react';

import { Checkbox } from './Form/Checkbox';
import PreviewImage from './Map/PreviewImage';
import { Layers } from '../stores/layers';

import { joinText } from '../helpers/textUtils';
import { higestRankedCategory } from '../helpers/poiHelper';
import { useTranslateFunction } from '../helpers/useTranslationHook';

export const Favorite = ({
  poi,
  language,
  onSeletionChanged,
  onClick,
  selectable,
  selected,
  description = null,
}) => {
  const cityAndCountryString = joinText(
    [poi?.address?.city, poi?.address?.country],
    ', ',
  );

  const { t } = useTranslateFunction(Layers.filter);
  return (
    <div
      className="bg-white mb-3 relative cursor-pointer overflow-hidden w-full flex shadow-md rounded-md transition-all hover:bg-gray-100"
      onClick={(event) => {
        event.stopPropagation();
        if (onClick) onClick();
      }}
    >
      {selectable ? (
        <label onClick={(event) => event.stopPropagation()}>
          <Checkbox
            className="w-5 h-5 absolute top-2 left-2 z-10"
            rounded
            isChecked={selected}
            onChange={onSeletionChanged}
          />
        </label>
      ) : null}

      <PreviewImage
        className="!rounded-none"
        image={(poi.images?.length && poi.images[0]?.url) || ''}
        category={poi.categories[0]}
      />

      <div className="w-full overflow-hidden p-4 border-t border-b border-r rounded-r-md">
        <div className="relative pl-5 text-sm text-neutral-400">
          <span
            className={`absolute top-1 left-0 gys gys-${poi.categories[0]?.name}`}
          ></span>
          {t(higestRankedCategory(poi).name)}
        </div>
        <div className="my-1 overflow-hidden text-ellipsis whitespace-nowrap text-lg font-semibold text-neutral-900">
          {poi[language]?.title || ''}
        </div>
        {description ? (
          <div className="text-neutral-500 text-sm">{description}</div>
        ) : null}
        <div className="text-neutral-500 text-sm">{cityAndCountryString}</div>
      </div>
    </div>
  );
};
